// @ts-nocheck
import React, { Component } from 'react';
import { inject, observer } from "../../../../stores/mobx-compat";
import { Link } from 'react-router-dom';

import configs from '../configs';
import { IntegrationLayout } from '../_shared';
import Card, { CardHead } from '../../../ui/Card';
import Button from '../../../ui/Button';
import Switch from '../../../ui/Switch';
import Alert from '../../../ui/Alert';

class WiX extends Component {
  componentDidMount() {
    this.props.store.integrations.WiX.getConfigs();
    this.props.store.integrations.WiX.getAuthUrl();
  }

  toggle = (v) => {
    this.props.store.integrations.WiX.setConfigField('enabled', v);
  }

  render() {
    const wix = this.props.store.integrations.WiX;
    const { appInstance } = wix.configs;

    const statusRows = appInstance ? [
      { name: 'App Name', value: appInstance.instance?.appName },
      { name: 'App Version', value: appInstance.instance?.appVersion },
      { name: 'Site Name', value: appInstance.site?.siteDisplayName },
    ] : null;

    return (
      <IntegrationLayout config={configs.WiX}>
        <Alert tone="warn" title="In development">
          This integration is currently in development and is not yet in the WiX App Market.
        </Alert>

        <Card padded className="mt-5 mb-5">
          <CardHead title="Setup" />
          <ol className="m-0 pl-5 flex flex-col gap-2 text-[13px] leading-relaxed">
            <li>Make a WiX account if you don&apos;t have one already.</li>
            <li>
              Head over to{' '}
              <a href="https://www.wix.com/app-market/main" target="_blank" rel="noopener noreferrer" className="text-mov-accent-ink underline">
                the WiX App Market
              </a>.
            </li>
            <li>Search for: Capture Movology.</li>
            <li>Hit &quot;Install App&quot;.</li>
            <li>Give Capture necessary permissions.</li>
            <li>
              Captures appear in{' '}
              <Link to="/dashboard" className="text-mov-accent-ink underline">dashboard</Link>,{' '}
              <Link to="/reporting" className="text-mov-accent-ink underline">reporting</Link>, and your WiX Hive (pending).
            </li>
          </ol>
        </Card>

        {statusRows && (
          <Card padded className="mb-5">
            <CardHead title="Status" />
            <dl className="m-0 grid gap-2.5 text-[13px]">
              {statusRows.map((r) => (
                <div key={r.name} className="flex justify-between gap-3" style={{ borderBottom: '1px dashed var(--mov-line)', paddingBottom: 8 }}>
                  <dt className="text-mov-ink-mute mov-mono text-[11px] uppercase tracking-wider">{r.name}</dt>
                  <dd className="m-0 font-medium">{r.value}</dd>
                </div>
              ))}
            </dl>
          </Card>
        )}

        <Card padded>
          <CardHead
            title="Manage integration"
            action={(
              <div className="flex items-center gap-2">
                <span className="text-[12.5px] text-mov-ink-soft">Enabled</span>
                <Switch checked={!!wix.configs.enabled} onChange={this.toggle} />
              </div>
            )}
          />
          <div className="flex justify-end">
            <Button
              variant="primary"
              loading={wix.loading}
              disabled={wix.loading}
              onClick={() => wix.updateConfigs()}
            >
              Update settings
            </Button>
          </div>
        </Card>
      </IntegrationLayout>
    );
  }
}

export default inject('store')(observer(WiX));
